<template>
  <div>
    <base-header v-once pageName="설정" :popup="true"></base-header>

    <section id="wrap">
      <div class="pushInfo">
    
        <div>
            <strong>흔들기 설정</strong>
            
            <span class="set">
                <input type="checkbox" 
                id="shakeYn"
                v-model="shakeYn"
                true-value="Y"
                false-value="N"
                @change="saveShake" >
                <label for="shakeYn"></label>
            </span>
        </div>
        <ul>
            <li>QR인증 ↔ 고객등록
                <span class="set revers">
                    <input type="checkbox" 
                    id="shakeSelect"
                    v-model="shakeSelectVal"
                    true-value="CSTMR"
                    false-value="QR" 
                    :disabled="shakeYn == 'N'"
                    @change="saveShake" >
                    <label for="shakeSelect"></label>
                </span>
            </li>
        </ul>
        
        <div>
          <strong>앱 알림 설정</strong>
          <p>푸시 전체 알림 받기</p>

          <span class="set">
            <input
              type="checkbox"             
              id="allRecpYn"
              v-model="allRecpYn"
              true-value="Y"
              false-value="N"
              @change="chkAllRecp"
            />
            <label for="allRecpYn"></label>
          </span>
        </div>
        <ul>
          <li>
            고객등록
            <span class="set">
              <input
                type="checkbox"               
                id="custrgsnRecpYn"
                v-model="custrgsnRecpYn"
                true-value="Y"
                false-value="N"
                @change="saveUserInfo"
              />
              <label for="custrgsnRecpYn"></label>
            </span>
          </li>
          <li>
            공지
            <span class="set">
              <input
                type="checkbox"               
                id="ancmRecpYn"
                v-model="ancmRecpYn"
                true-value="Y"
                false-value="N"
                @change="saveUserInfo"
              />
              <label for="ancmRecpYn"></label>
            </span>
          </li>
          <li>
            영업활동계획
            <span class="set">
              <input
                type="checkbox"               
                id="planRecpYn"
                v-model="planRecpYn"
                true-value="Y"
                false-value="N"
                @change="saveUserInfo"
              />
              <label for="planRecpYn"></label>
            </span>
          </li>
          <li>
            진단 서비스 재검사
            <span class="set">
              <input
                type="checkbox"               
                id="dgnssrvcRecpYn"
                v-model="dgnssrvcRecpYn"
                true-value="Y"
                false-value="N"
                @change="saveUserInfo"
              />
              <label for="dgnssrvcRecpYn"></label>
            </span>
          </li>
          <li>
            상품 배송 정보
            <span class="set">
              <input
                type="checkbox"               
                id="shpnRecpYn"
                v-model="shpnRecpYn"
                true-value="Y"
                false-value="N"
                @change="saveUserInfo"
              />
              <label for="shpnRecpYn"></label>
            </span>
          </li>
          <li>
            일일리포트
            <span class="set">
              <input
                type="checkbox"               
                id="drptRecpYn"
                v-model="drptRecpYn"
                true-value="Y"
                false-value="N"
                @change="saveUserInfo"
              />
              <label for="drptRecpYn"></label>
            </span>
          </li>
        </ul>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  data: function data() {
    return {
      allRecpYn: "N",
      custrgsnRecpYn: "N",
      ancmRecpYn: "N",
      planRecpYn: "N",
      dgnssrvcRecpYn: "N",
      shpnRecpYn: "N",
      drptRecpYn: "N",

      shakeYn: "Y",
      shakeSelectVal: "CSTMR"
    };
  },
  watch: {
    '$store.state.ui.appdb': function()  {
      var key = this.$store.state.ui.appdb.key;
      var value = this.$store.state.ui.appdb.value;
      if(value == '') {
        return;
      }

      if(key == 'shake') {
        var data = JSON.parse(value);
        if(data.type == 'CSTMR_REG') {
          // 고객등록
          this.shakeSelectVal = "CSTMR";
          this.shakeYn = "Y";
        } else if(data.type == 'QR_AUTH') {
          // QR인증
          this.shakeSelectVal = "QR";
          this.shakeYn = "Y";
        } else if(data.type == 'NONE'){
          // 사용안함
          this.shakeYn = "N";
        }
      }
    }
  },
  methods: {
    chkAllRecp: function () {
      var allChecked = this.allRecpYn;
      if (allChecked == "Y") {
        this.custrgsnRecpYn = "Y";
        this.ancmRecpYn = "Y";
        this.planRecpYn = "Y";
        this.dgnssrvcRecpYn = "Y";
        this.shpnRecpYn = "Y";
        this.drptRecpYn = "Y";
      } else {
        this.custrgsnRecpYn = "N";
        this.ancmRecpYn = "N";
        this.planRecpYn = "N";
        this.dgnssrvcRecpYn = "N";
        this.shpnRecpYn = "N";
        this.drptRecpYn = "N";
      }
      this.saveUserInfo();
    },
    saveUserInfo: function () {
      var that = this;
      var params = this.params();
      this.$api.set
        .saveNotificationSetUserInfo(params)
        .then(function () {
          that.setAllCheckBox();
        })
        .catch(function (error) {
          alert(error.rtMsg);
        });
    },
    params() {
      return {
        custrgsnRecpYn: this.custrgsnRecpYn,
        ancmRecpYn: this.ancmRecpYn,
        planRecpYn: this.planRecpYn,
        dgnssrvcRecpYn: this.dgnssrvcRecpYn,
        shpnRecpYn: this.shpnRecpYn,
        drptRecpYn: this.drptRecpYn,
      };
    },
    isAllChecked() {
        if(this.custrgsnRecpYn != "Y") {
            return false;
        }
        if(this.ancmRecpYn != "Y") {
            return false;
        }
        if(this.planRecpYn != "Y") {
            return false;
        }
        if(this.dgnssrvcRecpYn != "Y") {
            return false;
        }
        if(this.shpnRecpYn != "Y") {
            return false;
        }
        if(this.drptRecpYn != "Y") {
            return false;
        }
        return true;
    },
    setAllCheckBox() {
        if(this.isAllChecked()) {
            this.allRecpYn = 'Y';
        } else {
            this.allRecpYn = 'N';
        }
    }, 
    saveShake() {
      var data = {};
      if(this.shakeYn == "N") {
        // 사용안함
        data.type = 'NONE';   
        data.url  = '';
      } else {
        if(this.shakeSelectVal == "CSTMR") { 
          // 고객등록
          data.type = 'CSTMR_REG'; 
          data.url  = '/myCstmr/myCstmrReg';
        } else if(this.shakeSelectVal == "QR") {
          // QR인증
          data.type = 'QR_AUTH';   
          data.url  = '/eduKakaoSync';
        } 
      }
      this.$utils.nativeIf.outbound.setAppDB("shake", JSON.stringify(data));
    },
  },
  created: function () {
    var that = this;
    this.$api.set
      .getNotificationSetUserInfo({})
      .then(function (data) {
        console.log(
          "NotificationSet.vue <api.set.notificationSetUserInfo.response>",
          data
        );
        that.custrgsnRecpYn = data.custrgsnRecpYn;
        that.ancmRecpYn = data.ancmRecpYn;
        that.planRecpYn = data.planRecpYn;
        that.dgnssrvcRecpYn = data.dgnssrvcRecpYn;
        that.shpnRecpYn = data.shpnRecpYn;
        that.drptRecpYn = data.drptRecpYn;
        that.setAllCheckBox();
      })
      .catch(function (error) {
        alert(error.rtMsg);
      });
      this.$utils.nativeIf.outbound.getAppDB("shake");
  },
};
</script>
